// nevigation links active on header and footer script 

document.addEventListener('DOMContentLoaded', function() {
  var currentPath = window.location.pathname;

  // ---- HEADER top-level active ----
  var navLinks = document.querySelectorAll(
    '.header__links-primary .header__links-list > li > a[data-link]'
  );
  navLinks.forEach(function(link) {
    var rawHref = link.getAttribute('href');
    var isHashLink = !rawHref || rawHref === '#' || rawHref.startsWith('#');

    // Only do direct path match if it's a real link (not #)
    if (!isHashLink) {
      var linkPath = new URL(link.href).pathname;
      if (currentPath === linkPath) {
        link.classList.add('nav-active');
        return;
      }
    }

    // Always check submenu children (even for # parent links like "Shop by Theme")
    var parentLi = link.closest('li');
    if (parentLi) {
      var subLinks = parentLi.querySelectorAll('a[href]');
      subLinks.forEach(function(subLink) {
        try {
          var subRawHref = subLink.getAttribute('href');
          if (!subRawHref || subRawHref === '#' || subRawHref.startsWith('#')) return;

          var subPath = new URL(subLink.href).pathname;
          if (currentPath === subPath) {
            link.classList.add('nav-active');       // Highlight "Shop by Theme"
            subLink.classList.add('submenu-nav-active'); // Highlight "Annabel (all pink)"
          }
        } catch(e) {}
      });
    }
  });

  // ---- FOOTER active ----
  var footerLinks = document.querySelectorAll('.footer__links a');
  footerLinks.forEach(function(link) {
    try {
      var rawHref = link.getAttribute('href');
      if (!rawHref || rawHref === '#' || rawHref.startsWith('#')) return;

      var linkPath = new URL(link.href).pathname;
      if (currentPath === linkPath) {
        link.classList.add('footer-nav-active');
      }
    } catch(e) {}
  });

});


// back to top scroll on long pages script 

  window.addEventListener('scroll', function() {
    var backToTop = document.querySelector('.back-to-top[data-back-to-top]');
    if (!backToTop) return;

    if (window.scrollY > 10) {
      // 10px scroll ke baad visible class add karo
      backToTop.classList.add('visible');
    } else {
      // Top pe wapas aao toh visible class remove karo
      backToTop.classList.remove('visible');
    }
  });




// single product page quantity button script

  document.addEventListener('DOMContentLoaded', function() {

    function getStickyInput() {
      return document.querySelector('[data-sticky-qty-input]');
    }
    function getMainInput() {
      return document.querySelector('input.quantity-input__input[data-quantity-input]');
    }

    // ── Sticky − / + buttons ──
    document.addEventListener('click', function(e) {

      // Sticky MINUS
      if (e.target.matches('[data-sticky-qty-minus]')) {
        var stickyInput = getStickyInput();
        if (parseInt(stickyInput.value) > 1) {
          stickyInput.value = parseInt(stickyInput.value) - 1;
          updateMain(stickyInput.value);
        }
      }

      // Sticky PLUS
      if (e.target.matches('[data-sticky-qty-plus]')) {
        var stickyInput = getStickyInput();
        stickyInput.value = parseInt(stickyInput.value) + 1;
        updateMain(stickyInput.value);
      }

      // Main MINUS → Sticky update
      if (e.target.matches('[data-subtract-quantity]')) {
        setTimeout(function() {
          var mainInput = getMainInput();
          var stickyInput = getStickyInput();
          if (mainInput && stickyInput) {
            stickyInput.value = mainInput.value;
          }
        }, 50);
      }

      // Main PLUS → Sticky update
      if (e.target.matches('[data-add-quantity]')) {
        setTimeout(function() {
          var mainInput = getMainInput();
          var stickyInput = getStickyInput();
          if (mainInput && stickyInput) {
            stickyInput.value = mainInput.value;
          }
        }, 50);
      }
    });

    // ── Main input direct change → Sticky update ──
    document.addEventListener('change', function(e) {
      if (e.target.matches('input.quantity-input__input[data-quantity-input]')) {
        var stickyInput = getStickyInput();
        if (stickyInput) stickyInput.value = e.target.value;
      }
    });

    // ── Sticky input direct type → Main update ──
    document.addEventListener('input', function(e) {
      if (e.target.matches('[data-sticky-qty-input]')) {
        updateMain(e.target.value);
      }
    });

    // ── Helper ──
    function updateMain(val) {
      var mainInput = getMainInput();
      if (mainInput) {
        mainInput.value = val;
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

  });



// short by filter mobile script 

document.addEventListener('DOMContentLoaded', function() {

  function showSortChip() {
    // Purana chip remove karo
    var oldChip = document.querySelector('.mobile-sort-chip');
    if (oldChip) oldChip.remove();

    var sortBy = new URLSearchParams(window.location.search).get('sort_by');
    if (!sortBy) return;

    // Dynamic — DOM se checked radio ka label read karo
    var checkedInput = document.querySelector(
      '[data-filter-modal="__sort"] input[value="' + sortBy + '"], ' +
      '[data-filter-drawer] input[name="sort_by"][value="' + sortBy + '"]'
    );

    var label = null;

    if (checkedInput) {
      // Label element se text nikalo
      var labelEl = document.querySelector('label[for="' + checkedInput.id + '"]');
      if (labelEl) {
        label = labelEl.textContent.trim();
      }
    }

    // Fallback — agar DOM mein nahi mila to value ko readable banao
    if (!label) {
      label = sortBy
        .replace(/-/g, ' ')
        .replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    }

    // Sort button dhundo
    var sortBtn = document.querySelector(
      '.mobile-filters__button[data-filter-drawer-target="__sort"]'
    );
    if (!sortBtn) return;

    // Chip banao
    var chip = document.createElement('div');
    chip.className = 'mobile-sort-chip';
    chip.innerHTML = '<span>' + label + '</span>' +
      '<button class="mobile-sort-chip__remove" aria-label="Remove sort">&#10005;</button>';

    sortBtn.parentNode.insertAdjacentElement('afterend', chip);

    // ✕ click pe sort remove karo
    chip.querySelector('.mobile-sort-chip__remove').addEventListener('click', function() {
      var url = new URL(window.location.href);
      url.searchParams.delete('sort_by');
      window.location.href = url.toString();
    });
  }

  showSortChip();

  // URL change detect karo
  var lastUrl = location.href;
  var observer = new MutationObserver(function() {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(showSortChip, 100);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Done button click
  document.addEventListener('click', function(e) {
    var doneBtn = e.target.closest('[data-button="close"]') ||
                  e.target.closest('.filter-drawer__done') ||
                  (e.target.textContent.trim() === 'Done' ? e.target : null);
    if (doneBtn) {
      setTimeout(showSortChip, 500);
    }
  });

  // Popstate
  window.addEventListener('popstate', function() {
    setTimeout(showSortChip, 300);
  });

  // collection:updated
  document.addEventListener('collection:updated', function() {
    setTimeout(showSortChip, 300);
  });

});


 // after Contact form submittion scroll faq section script 


document.addEventListener('DOMContentLoaded', function() {

  if (window.location.search.indexOf('contact_posted=true') === -1) return;

  setTimeout(function() {

    // Success message dhundo
    var successMsg = document.querySelector('.form-status-list') ||
                     document.querySelector('[data-form-status]') ||
                     document.querySelector('.contact-form .form-status') ||
                     document.querySelector('form[action="/contact"] p') ||
                     document.querySelector('.shopify-challenge__container');

    // Form dhundo  
    var formTarget = document.querySelector('form[action="/contact"]') ||
                     document.querySelector('.contact-form');

    var scrollTarget = successMsg || formTarget;

    if (scrollTarget) {
      // Sticky header ki exact height lo
      var header = document.querySelector('.header__parent') ||
                   document.querySelector('header') ||
                   document.querySelector('.header');
      
      var headerHeight = header ? header.offsetHeight : 130;
      var extraPadding = 30; // Thoda breathing room

      var elementTop = scrollTarget.getBoundingClientRect().top + window.scrollY;
      var scrollTo = elementTop - headerHeight - extraPadding;

      window.scrollTo({ 
        top: Math.max(0, scrollTo), 
        behavior: 'smooth' 
      });
    }

  }, 200);

});
